enum DepositType {
	None = "None",
	Now = "Now",
	AfterMeasurement = "AfterMeasurement",
	AfterDossierCompletion = "AfterDossierCompletion"
}

export default DepositType;
